import type { RouteRecordRaw } from 'vue-router'
import { ADMIN_RBAC_PERMISSIONS } from '@/config/admin/rbac'

export const adminReviewRoutes: RouteRecordRaw[] = [
  // 内容审核
  {
    path: 'review/tasks',
    name: 'AdminTaskReviewList',
    component: () => import('@/views/admin/review/TaskReviewListPage.vue'),
    meta: {
      title: '任务审核',
      sidebarId: 'task-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_TASK_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'review/tasks/:id',
    name: 'AdminTaskReviewDetail',
    component: () => import('@/views/admin/review/TaskReviewDetailPage.vue'),
    meta: {
      title: '任务审核详情',
      sidebarId: 'task-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_TASK_VIEW],
      breadcrumb: true,
    },
  },
  {
    path: 'review/models',
    name: 'AdminModelReviewList',
    component: () => import('@/views/admin/review/ModelReviewListPage.vue'),
    meta: {
      title: '模型审核',
      sidebarId: 'model-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_MODEL_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'review/models/:id',
    name: 'AdminModelReviewDetail',
    component: () => import('@/views/admin/review/ModelReviewDetailPage.vue'),
    meta: {
      title: '模型审核详情',
      sidebarId: 'model-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_MODEL_VIEW],
      breadcrumb: true,
    },
  },
  {
    path: 'review/bids',
    name: 'AdminBidReviewList',
    component: () => import('@/views/admin/review/BidReviewListPage.vue'),
    meta: {
      title: '投标审核',
      sidebarId: 'bid-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_BID_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'review/bids/:id',
    name: 'AdminBidReviewDetail',
    component: () => import('@/views/admin/review/BidReviewDetailPage.vue'),
    meta: {
      title: '投标审核详情',
      sidebarId: 'bid-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_BID_VIEW],
      breadcrumb: true,
    },
  },

  // 身份审核
  {
    path: 'review/designers',
    name: 'AdminDesignerReviewList',
    component: () => import('@/views/admin/review/DesignerReviewListPage.vue'),
    meta: {
      title: '设计师认证',
      sidebarId: 'designer-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_DESIGNER_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'review/designers/:id',
    name: 'AdminDesignerReviewDetail',
    component: () => import('@/views/admin/review/DesignerReviewDetailPage.vue'),
    meta: {
      title: '设计师认证详情',
      sidebarId: 'designer-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_DESIGNER_VIEW],
      breadcrumb: true,
    },
  },
  {
    path: 'review/providers',
    name: 'AdminProviderReviewList',
    component: () => import('@/views/admin/review/ProviderReviewListPage.vue'),
    meta: {
      title: '服务商认证',
      sidebarId: 'provider-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_PROVIDER_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'review/providers/:id',
    name: 'AdminProviderReviewDetail',
    component: () => import('@/views/admin/review/ProviderReviewDetailPage.vue'),
    meta: {
      title: '服务商认证详情',
      sidebarId: 'provider-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_PROVIDER_VIEW],
      breadcrumb: true,
    },
  },
  {
    path: 'review/designer-projects',
    name: 'AdminDesignerProjectReviewList',
    component: () => import('@/views/admin/review/DesignerProjectReviewListPage.vue'),
    meta: {
      title: '设计师项目',
      sidebarId: 'designer-project-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_DESIGNER_PROJECT_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'review/designer-projects/:id',
    name: 'AdminDesignerProjectReviewDetail',
    component: () => import('@/views/admin/review/DesignerProjectReviewDetailPage.vue'),
    meta: {
      title: '设计师项目详情',
      sidebarId: 'designer-project-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_DESIGNER_PROJECT_VIEW],
      breadcrumb: true,
    },
  },
  {
    path: 'review/provider-projects',
    name: 'AdminProviderProjectReviewList',
    component: () => import('@/views/admin/review/ProviderProjectReviewListPage.vue'),
    meta: {
      title: '服务商项目',
      sidebarId: 'provider-project-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_PROVIDER_PROJECT_VIEW],
      breadcrumb: true,
      cache: true,
    },
  },
  {
    path: 'review/provider-projects/:id',
    name: 'AdminProviderProjectReviewDetail',
    component: () => import('@/views/admin/review/ProviderProjectReviewDetailPage.vue'),
    meta: {
      title: '服务商项目详情',
      sidebarId: 'provider-project-review',
      permissions: [ADMIN_RBAC_PERMISSIONS.MODERATION_PROVIDER_PROJECT_VIEW],
      breadcrumb: true,
    },
  },
]
